// extracted by mini-css-extract-plugin
export var cardIcon = "_93-5";
export var checkboxCard = "_93-0";
export var checkboxCardSelected = "_93-4";
export var disabled = "_93-2";
export var interactive = "_93-1";
export var outerBorder = "_93-3";
export var spacerMedium = "_93-8";
export var spacerSmall = "_93-7";
export var spacerXsmall = "_93-6";